<div id="header-component" [ngClass]="{'compact-header': compact, 'width-auto': !userName}" class="bg-color-a">
    <mat-toolbar class="header-toolbar-bg">
        <div class="flex-centered-container-vr fill-height">
            <button mat-icon-button class="toggle-menu-btn" (click)="toggleSideMenu()" *ngIf="userName && !(isAdmin || hideHeader)">
                <mat-icon>menu</mat-icon>
            </button>
            <img (click)="redirectToHome()" [src]="logoUrl" class="fake-button header-logo">
            <!-- <div *ngIf="!isAdmin" class="border-separater margin-4-hr"></div> -->
            <!-- <img (click)="redirectToHome()" src="/assets/navbarHomeIcon.svg" class="home-icon cursor-pointer"> -->
            <div class="flex-centered-container-vr nav-links fill-height" *ngIf="userName && !(isAdmin || hideHeader)">
                <ng-container *ngFor="let tab of headerItems">
                    <ng-container *ngIf="!tab.tool else toolsMenu">
                        <a mat-button (click)="navigateToComponent(tab)" class="tabs-padding dynamic-tab flex-centered-container font-500 primary-dark-text" routerLinkActive="active-tab"
                        *ngIf="tab.visible === undefined ? true : tab.visible" tabindex="-1">
                            {{tab.label}}
                        </a>
                    </ng-container>
                    
                    <ng-template #toolsMenu>
                        <button mat-button [matMenuTriggerFor]="menu"  #trigger="matMenuTrigger" class="dynamic-tab tools-padding cursor-pointer" 
                            (menuOpened)="isMenuOpen = trigger.menuOpen" (menuClosed)="isMenuOpen = trigger.menuOpen"  [class.active-tab]="isActiveRoute(tab)">
                            <span class="flex-centered-container">
                                <span>{{tab.label}}</span>
                                <mat-icon class="tool-menu position-relative font-18 margin-4-left">{{isMenuOpen ? "expand_less" : "expand_more"}}</mat-icon>
                            </span>
                        </button>
                        <div class="tool-block">
                            <mat-menu #menu="matMenu">
                                <ng-continer *ngFor="let tool of toolItems">
                                    <a mat-menu-item (click)="navigateToComponent(tool)"[tabIndex]="0"
                                        *ngIf="tool.visible === undefined ? true : tool.visible">
                                        <img [src]="tool.img">
                                        <mat-button mat-button tabindex="-1" [value]="tool.label" class="tool-btn padding-12-hr primary-dark-text" disableRipple>
                                            {{tool.label}}
                                        </mat-button>
                                    </a>
                                </ng-continer>
                            </mat-menu>
                        </div>
                    </ng-template>
                </ng-container>
            </div>
        </div>

        <!-- <div *ngIf="!isAdmin" class="border-separater margin-4-hr"></div> -->
        <span class="spacer"></span>

        <ng-container *ngIf="!hideHeader">
            <div *ngIf="!userName">
                <mat-button-toggle-group appearance="legacy"
                    class="dashboard-tabs defualt-mat-button-toggle-group no-shadow">
                    <a routerLink="/auth/login">
                        <mat-button-toggle value="Login" disableRipple>
                            <span class="font-18">Login</span>
                        </mat-button-toggle>
                    </a>
                </mat-button-toggle-group>
            </div>

            <div *ngIf="userName" class="flex-centered-container-vr">
                <ng-template [ngIf]="!isAdmin">
                    <mat-menu #createAlgoMenuRef="matMenu">
                        <span *ngFor="let method of createPortfolioMethods">
                            <button class="font-12" mat-menu-item (click)="createNewPortfolio(method.route)"
                                tabindex="0">{{method.label}}</button>
                        </span>
                    </mat-menu>

                    <mat-icon class="margin-8-right fake-button ai-icon" role="button"
                        tabindex="0" (keydown.enter)="fixedAifunction()" (click)="fixedAifunction()"
                        matTooltip="uTrade Intelligence"  matTooltipPosition="below"
                        svgIcon="utradeAiBot">
                    </mat-icon>
                    
                    <mat-icon  matTooltip="What's New" matTooltipPosition="below"
                        class="margin-8-right cursor-pointer placeholder-text" (click)="openWhatsNew()" *ngIf="whatsNewLink">campaign</mat-icon>

                    <mat-icon #notificationIcon class="outline fake-button material-icons-outlined notifications placeholder-text" 
                        tabindex="0" (keydown.enter)="openNotificationPanel()" (click)="openNotificationPanel()" role="button"
                        matTooltip="Notifications" matTooltipPosition="below"
                        [matBadge]="notificationBadge" matBadgeColor="warn" matBadgeSize="small" [matBadgeHidden]="notificationCount === 0">
                        notifications
                    </mat-icon>
                </ng-template>
                <button mat-icon-button #profileIcon class="avatar" (click)="openProfileCard()" tabindex="0">
                    <mat-icon>
                        <app-display-picture class="image" [size]="26"> </app-display-picture>
                    </mat-icon>
                </button>
            </div>
        </ng-container>
    </mat-toolbar>
</div>